import { render, staticRenderFns } from "./ExcuseTypeView.vue?vue&type=template&id=2f1fb55f&"
import script from "./ExcuseTypeView.vue?vue&type=script&lang=js&"
export * from "./ExcuseTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports